export default function ({ store, route}) {
  route.meta.map((meta) => {
    const token = localStorage.getItem('token')
    const user = localStorage.getItem('user')

    if(!meta.requiresAuth) return true

    if (meta.requiresAuth && token !== null && token !== "" && user !== null && user !== "") {
      return true
    }else{
      localStorage.clear()
      window.location.href = '/auth/login'
      return false
    }
  })
}
